export const IconProSubs = (props) => {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="50" height="50" rx="10" fill="#F2F4F8" />
      <path
        d="M41.3452 32.3306C41.6428 31.5996 42.6778 31.5996 42.9754 32.3306L43.3154 33.166C43.412 33.4033 43.6072 33.5867 43.8499 33.6684L44.5209 33.894C45.3201 34.1629 45.3201 35.2933 44.5209 35.5622L43.8499 35.7879C43.6072 35.8696 43.412 36.0529 43.3154 36.2902L42.9754 37.1257C42.6778 37.8567 41.6428 37.8567 41.3452 37.1257L41.0052 36.2902C40.9086 36.0529 40.7135 35.8696 40.4707 35.7879L39.7998 35.5622C39.0005 35.2933 39.0005 34.1629 39.7998 33.894L40.4707 33.6684C40.7135 33.5867 40.9086 33.4033 41.0052 33.166L41.3452 32.3306Z"
        fill="#302571"
      />
      <circle cx="24.5447" cy="25.99" r="1.95875" fill="#302571" />
      <path
        d="M24.5448 34.8006C29.4129 34.8006 33.3592 30.8543 33.3592 25.9862C33.3592 21.1182 29.4129 17.1719 24.5448 17.1719C19.6768 17.1719 15.7305 21.1182 15.7305 25.9862"
        stroke="#D7D7D7"
        stroke-width="1.76"
        stroke-linecap="round"
      />
      <path
        d="M33.5093 37.628C39.9374 32.6776 41.1353 23.4535 36.1849 17.0254C32.648 12.4327 26.9294 10.5098 21.6077 11.5917"
        stroke="#D7D7D7"
        stroke-width="1.76"
        stroke-linecap="round"
      />
      <path
        d="M13.1714 16.0113C7.55413 21.8657 7.74628 31.1653 13.6006 36.7826C16.6502 39.7087 20.6346 41.0584 24.5465 40.8526"
        stroke="#D7D7D7"
        stroke-width="1.76"
        stroke-linecap="round"
      />
      <circle cx="15.7311" cy="28.9225" r="2.93812" fill="#302571" />
      <circle
        cx="14.3151"
        cy="15.7501"
        r="3.9175"
        transform="rotate(171.417 14.3151 15.7501)"
        fill="#302571"
      />
      <path
        d="M31.8227 35.1991C32.1062 34.433 33.1899 34.433 33.4734 35.1991L33.9962 36.612C34.0853 36.8529 34.2752 37.0428 34.5161 37.1319L35.929 37.6548C36.6952 37.9383 36.6952 39.0219 35.929 39.3054L34.5161 39.8282C34.2752 39.9174 34.0853 40.1073 33.9962 40.3481L33.4734 41.7611C33.1899 42.5272 32.1062 42.5272 31.8227 41.7611L31.2999 40.3481C31.2108 40.1073 31.0209 39.9174 30.78 39.8282L29.3671 39.3054C28.6009 39.0219 28.6009 37.9383 29.3671 37.6548L30.78 37.1319C31.0209 37.0428 31.2108 36.8529 31.2999 36.612L31.8227 35.1991Z"
        fill="#302571"
      />
    </svg>
  );
};
